import React, { forwardRef } from 'react';
import { FieldTypes } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import Rapid7InsightMappingForm from './Rapid7InsightMappingForm';

const Rapid7InsightCredentialsForm = forwardRef((props, ref) => {
    const fields = [
        {
            name: "region_code",
            label: "Rapid7 Insight Region Code",
            rules: [{
                required: true,
                message: "Region Code is required"
            }]
        },
        {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        }
    ];
    return (
        <GenericPullCredentialsForm 
         {...props} 
         ref={ref}
         fields={fields}
         MappingForm={Rapid7InsightMappingForm}
          />
    )
});

export default Rapid7InsightCredentialsForm;